import React from 'react';
import styles from './styles.scss';

const DiscloseInfoTextLabel = ({ i18n }) => (
  <div>
    {i18n('intermediary.dataProtection.discloseInformationToThirdPartyLabel')}
    <div className={styles.discloseInfoTextLabel}>
      {i18n(
        'intermediary.dataProtection.discloseInformationToThirdPartyDescription'
      )}
    </div>
  </div>
);

export default DiscloseInfoTextLabel;
